import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { PdfDocumentIcon } from "../../ui/icons/PdfDocumentIcon"
import { SquaredTickIcon } from "../../ui/icons/SquaredTickIcon"
import { AssignmentStateOptions, normativa, optionsFormatter } from "../../utils"
import { AssignmentDTO } from "./dataservice/dto"
import { AssignmentDelete, AssignmentUpdate, GetAllAssignment, GetAssignmentById, resetAssigmentDeleteStatus, resetAssigmentUpdateStatus, setAssignmentIdToUpdate, setAssignmentPMId, setAssUpdateAssignmentPlace, setAssUpdateAssignmentUcoVerDate, setAssUpdateAssignmentUcoVerUserId, setAssUpdateDepartureProtocolId, setAssUpdatePMContractId, setAssUpdateReference, setAssUpdateRevocationProtocolId, setAssUpdateSignedAssignmentLetterId, setAssUpdateState } from "./slice"
import { useNavigate } from "react-router-dom"
import { EditIcon } from "../../ui/icons/edit"
import { TrashIcon } from "../../ui/icons/trash"
import { DeclinedIcon } from "../../ui/icons/declined"
import { Alert } from "../../ui/organisms/alert"
import Button from "../../ui/molecules/button"
import { PopupForm } from "../../ui/organisms/popupForm"
import { EditAssignmentPopup } from "./editAssignment/editPopup"
import { VerifiedIcon } from "../../ui/icons/verified"
import { AlertIcon } from "../../ui/icons/alertIcon"
import { MagnifyingIcon } from "../../ui/icons/magnifying"
import { Calendar } from "../../ui/molecules/calendar"
import { format } from "date-fns"

export function AssignmentList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const assignmentState = useAppSelector(state => state.assignment)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [showSuccessEditAss, setShowSuccessEditAss] = useState<boolean>(false)
    const [showEditAssignment, setShowEditAssignment] = useState<boolean>(false)
    const [showDeleteConfirm, setShowDeleteConfirm] = useState<boolean>(false)
    const [showSuccessDeleteAss, setShowSuccessDeleteAss] = useState<boolean>(false)
    const [showVerificaUcoPopup, setShowVerificaUcoPopup] = useState<boolean>(false)
    const [textPopupIncarico, setTextPopupIncarico] = useState<string>('')
    const [ucoVerificationOfficerInfo, setUcoVerificationOfficerInfo] = useState<string>("");
    const usersState = useAppSelector(state => state.users)

    const onEditHandle = (ass: AssignmentDTO) => {
        dispatch(setAssignmentIdToUpdate(ass.id))
        dispatch(setAssignmentPMId(ass.personalManagementId))
        dispatch(GetAssignmentById(ass.id))
        dispatch(setAssUpdateReference(ass.reference))
        dispatch(setAssUpdateRevocationProtocolId(ass.revocationProtocolId))
        dispatch(setAssUpdateState(ass.state))
        dispatch(setAssUpdatePMContractId(ass.pmContractId))
        dispatch(setAssUpdateSignedAssignmentLetterId(ass.signedAssignmentLetterId))
        dispatch(setAssUpdateDepartureProtocolId(ass.departureProtocolId))
        dispatch(setAssUpdateAssignmentPlace(ass.assignmentPlace))
    }

    useEffect(() => {
        if (assignmentState.assignmentUpdateStatus === 'successfully') {
            dispatch(resetAssigmentUpdateStatus())
            setShowEditAssignment(false)
            setShowAlert(false)
            dispatch(GetAllAssignment(assignmentState.assignmentFilters))
            setShowEditAssignment(false)
            setShowVerificaUcoPopup(false)
            setShowSuccessEditAss(true)
            dispatch(GetAllAssignment(assignmentState.assignmentFilters))
            setTimeout(() => {
                setShowSuccessEditAss(false)
            }, 2500);
        }
    }, [assignmentState.assignmentUpdateStatus])

    useEffect(() => {
        if (assignmentState.assignmentDeleteStatus === 'successfully') {
            dispatch(resetAssigmentDeleteStatus())
            setShowSuccessDeleteAss(true)
            setShowDeleteConfirm(false)
            dispatch(GetAllAssignment(assignmentState.assignmentFilters))
            setTimeout(() => {
                setShowSuccessDeleteAss(false)
            }, 2500);
        }
    }, [assignmentState.assignmentDeleteStatus])

    return (
        <div style={{ padding: '24px' }}>
            {
                (showSuccessEditAss) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati Salvati correttamente.
                    </span>
                </div>
            }
            {
                (showSuccessDeleteAss) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Incarico Cancellato.
                    </span>
                </div>
            }
            <table id="list-table" className="w-[100%] assignment-table">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}>Operazioni</th>
                        <th className="width-[130px]" style={{ textAlign: 'center' }}>Incarico Accettato</th>
                        <th className="width-[130px]">Anno</th>
                        <th className="width-[130px]">Sede</th>
                        <th className="width-[130px]">Norma</th>
                        <th className="width-[100px]">Protocollo Incarico</th>
                        <th className="width-[130px]">Riferimento</th>
                        <th className="width-[130px]">Ispettore</th>
                        <th className="width-[130px]">Cod. Ispettore</th>
                        <th className="width-[130px]">Funzionario</th>
                        <th className="width-[130px]">Stato</th>
                        <th className="width-[130px]">incarico firmato</th>
                        <th style={{ borderTopRightRadius: '8px', width: '40px' }}>Verifica Uco</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        assignmentState.getAllAssignmentResponse?.data.map((ass, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td>
                                    <div className="flex justify-content-center align-items-center gap-[10px]">

                                        <button onClick={() => { navigate('/modificaIncarico'); onEditHandle(ass) }} className="tooltip-container">
                                            <SquaredTickIcon />
                                            <span className="tooltip-text">Apri Incarico</span>
                                        </button>
                                        <button onClick={() => {
                                            setShowEditAssignment(true);
                                            onEditHandle(ass);
                                            setTextPopupIncarico(ass.departureProtocolInfo)
                                        }
                                        }
                                            className="tooltip-container">
                                            <EditIcon color={"#FF941A"} size={20} />
                                            <span className="tooltip-text">Modifica Incarico</span>
                                        </button>
                                        <button onClick={() => {
                                            dispatch(setAssignmentIdToUpdate(ass.id))
                                            setShowDeleteConfirm(true)
                                            setTextPopupIncarico(ass.departureProtocolInfo)
                                        }
                                        }
                                            className="tooltip-container"
                                        >
                                            <TrashIcon color={"#DB0700"} size={20} />
                                            <span className="tooltip-text">Cancella Incarico</span>
                                        </button>

                                    </div>

                                </td>
                                <td>
                                    {ass.isAccepted !== null ? (
                                        ass.isAccepted === true ? (
                                            <div className="flex justify-content-center align-items-center gap-[10px]" style={{ justifyContent: 'center' }}>
                                                <VerifiedIcon />
                                            </div>
                                        ) : (
                                            <div className="flex justify-content-center align-items-center gap-[10px]" style={{ justifyContent: 'center' }}>
                                                <DeclinedIcon />
                                            </div>
                                        )
                                    ) : (
                                        <div className="flex justify-content-center align-items-center gap-[10px]" style={{ justifyContent: 'center' }}>
                                            <AlertIcon color='#FF443D' size={20} />
                                        </div>

                                    )}

                                </td>
                                <td>{ass.year}</td>
                                <td>{ass.departureProtocolHeadQuarter}</td>
                                <td>{optionsFormatter(ass.norm, normativa)}</td>
                                <td>{ass.departureProtocolInfo}</td>
                                <td>{ass.reference}</td>
                                <td>{ass.inspectorCode}</td>
                                <td>{ass.inspectorCode}</td>
                                <td>{ass.personalManagementInfo}</td>
                                <td>{optionsFormatter(ass.state, AssignmentStateOptions)}</td>
                                <td>{ass.signedAssignmentLetterInfo}</td>
                                <td>
                                    <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                        <button onClick={() => {
                                            setShowVerificaUcoPopup(true)
                                            dispatch(setAssUpdateAssignmentUcoVerDate(ass.ucoVerificationDate))
                                            setUcoVerificationOfficerInfo(ass.ucoVerificationOfficerInfo)
                                            dispatch(setAssignmentIdToUpdate(ass.id))
                                            console.log(ass.ucoVerificationOfficerInfo)
                                            setTextPopupIncarico(ass.departureProtocolInfo)
                                        }}>
                                            <MagnifyingIcon />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )}
                </tbody>
            </table>

            {
                showVerificaUcoPopup && (
                    <Alert title="Verifica Uco" close={() => setShowVerificaUcoPopup(false)} headerGreen={true}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3 mt-4">
                                <div>
                                    Verifica Uco per incarico <b>{textPopupIncarico}</b>
                                </div>
                            </div>
                            <div style={{ padding: '24px' }}>
                                <Calendar
                                    label="Data Verifica"
                                    onChange={(date) => {
                                        dispatch(setAssUpdateAssignmentUcoVerDate(format(new Date(date), 'yyyy-MM-dd')))
                                        dispatch(setAssUpdateAssignmentUcoVerUserId(usersState.findMeResponse.id))
                                    }}
                                    selected={assignmentState.assignmentUpdateRequest.ucoVerificationDate}
                                />
                            </div>
                            {
                            (ucoVerificationOfficerInfo !== "" && ucoVerificationOfficerInfo) && (
                                <div>
                                    Funzionario che ha verificato: <b>{ucoVerificationOfficerInfo}</b>
                                </div>
                            )
                            }

                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Chiudi finestra"
                                    size="md"
                                    onClick={() => setShowVerificaUcoPopup(false)}
                                />

                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color={'green'}
                                        iconPosition="off"
                                        label={'Conferma'}
                                        size="md"
                                        onClick={() => {
                                            dispatch(AssignmentUpdate(
                                                {
                                                    body: assignmentState.assignmentUpdateRequest,
                                                    id: assignmentState.assignmentIdToUpdate
                                                }))
                                        }
                                        }
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
            {
                showDeleteConfirm && (
                    <Alert title="Cancella Incarico" close={() => setShowDeleteConfirm(false)} headerGreen={true}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3 mt-4">
                                <div>
                                    Confermi la cancellazione dell'incarico con riferimento <b>{textPopupIncarico}</b>?
                                </div>
                            </div>

                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Chiudi finestra"
                                    size="md"
                                    onClick={() => setShowDeleteConfirm(false)}
                                />

                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color={'red'}
                                        iconPosition="off"
                                        label={'Conferma'}
                                        size="md"
                                        onClick={() => {
                                            dispatch(AssignmentDelete(assignmentState.assignmentIdToUpdate))
                                        }
                                        }
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
            {
                showEditAssignment && (
                    <PopupForm headerGreen={true} title={'Modifica Incarico  - ' + textPopupIncarico} close={() => {
                        setShowEditAssignment(false)
                    }}>
                        <EditAssignmentPopup />
                    </PopupForm>
                )
            }
        </div>
    )
}